module.exports = __webpack_public_path__ + "static/media/img_mobile_srp_device.547fbd79.png";